export const name = '_audius'
export const displayName = 'Audius'
export const ticker = `${name}_AUDIO`
export const displayTicker = 'AUDIO'
export const units = {
  [`${name}_base`]: 0,
  [ticker]: 18,
}
export const assetType = 'MULTI_NETWORK_ASSET'

export const combinedAssetNames = ['audius', 'audius_solana']
